/**
 * Shared field helpers: isValueFilled, preserveGlobalFields.
 */

export const isValueFilled = (value: any): boolean => {
  if (value === null || value === undefined || value === '') return false;
  if (typeof value === 'number') return true;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  if (value instanceof Date) return !isNaN(value.getTime());
  return true;
};

export const preserveGlobalFields = (
  newData: any,
  currentFormData: any,
  globalFields: string[] = [
    'contracts',
    'contractsData',
    'supplierName',
    'analysisDate',
    'targetLaunchDate',
    'analysisType',
    'productName',
    'analystName',
    'gsmsHndlgType',
  ]
): any => {
  const preservedGlobalFields: any = {};
  globalFields.forEach(field => {
    if (currentFormData[field] !== undefined) {
      preservedGlobalFields[field] = currentFormData[field];
    }
  });
  return {
    ...newData,
    ...preservedGlobalFields,
  };
};
